import styled, { css, keyframes } from "styled-components";

export const enterLeft = keyframes`
  from {
    opacity: 0;
    transform: translateX(-50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

export const enterRight = keyframes`
  from {
    opacity: 0;
    transform: translateX(50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

export const enterTop = keyframes`
  from {
    opacity: 0;
    transform: translateY(-50px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const opacity = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const enterFromBottom = keyframes`
  from {
    opacity: 0;
    transform: translateY(50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

const pulse = keyframes`
50% {
    opacity: 0.5;
  }
`;

export const CheckoutContainer = styled.section`
  display: flex;
  gap: 24px;
  position: relative;
`;

export const Label = styled.p`
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: middle;
  color: #62748e;
  margin-bottom: 16px;
  transition: all 300ms ease-in-out;

  ${({ error }) =>
    error &&
    css`
      color: #eb001b;
      animation: ${pulse} 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
    `}
`;

export const PaymentSummaryContainer = styled.div`
  border: 1px solid #e2e8f0;
  min-width: 406px;
  height: fit-content;
  padding: 24px;
  border-radius: 8px;

  animation: ${enterFromBottom} 1s;
`;

export const PaymentSummaryLabel = styled(Label)`
  color: #314158;
  margin-bottom: 8px;
`;

export const PaymentSummaryText = styled(PaymentSummaryLabel)`
  font-size: 14px;
  margin-bottom: 0;
  ${({ mb }) =>
    mb &&
    css`
      margin-bottom: ${mb};
    `}
  ${({ type }) => {
    switch (type) {
      default:
      case "text":
        return css`
          font-weight: 400;
        `;
      case "summary":
        return css`
          font-size: 16px;
          font-weight: 600;
        `;
      case "value":
        return css`
          font-weight: 600;
        `;

      case "bold":
        return css`
          font-size: 18px;
          font-weight: 700;
          color: #020618;
        `;
    }
  }}
`;

export const SummaryInfoContainer = styled.div`
  display: flex;
  gap: 16px;
  flex-direction: column;
  ${({ mb }) =>
    mb &&
    css`
      margin-bottom: ${mb};
    `}
`;

export const SummaryInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Divider = styled.div`
  border: 1px solid #e2e8f0;
  margin: 37px 0;
  width: 100%;
`;

export const PaymentMethodCard = styled.div`
  width: 266px;
  height: 97px;
  padding: 24px;
  border-radius: 8px;
  border-width: 2px;
  border-style: solid;
  border-color: #e2e8f0;
  cursor: pointer;
  transition: all 300ms ease-in-out;

  display: flex;
  justify-content: space-between;

  div {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  svg path {
    transition: all 300ms ease-in-out;
  }

  &:hover {
    border-color: rgba(6, 142, 195, 0.63);
    svg.fill path {
      fill: rgba(6, 142, 195, 0.63);
    }
    svg.stroke path {
      stroke: rgba(6, 142, 195, 0.63);
    }
  }

  span {
    font-family: "Inter", sans-serif;
    font-weight: 500;
    font-size: 14px;
    line-height: 100%;
    color: #62748e;
    text-transform: capitalize;
  }

  ${({ error }) =>
    error &&
    css`
      border-color: #eb001b;
    `}

  ${({ selected }) =>
    selected &&
    css`
      border-width: 2px;
      border-color: #068ec3;
      box-shadow: 2px 2px 15px 0px #5c5c5c33;

      span {
        font-weight: 600;
        color: #020618;
      }

      &:hover {
        border-color: #068ec3;
        svg.fill path {
          fill: #068ec3;
        }
        svg.stroke path {
          stroke: #068ec3;
        }
      }
    `}
`;

export const PaymentMethodCardContainer = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
`;

export const PaymentMethodContainer = styled.div`
  max-width: 830px;
  width: 100%;
  position: sticky;
  top: 0;
  animation: ${enterLeft} 1s;
`;

export const FormContainer = styled.div`
  animation: ${enterFromBottom} 1s;
`;

export const WarningContainer = styled.div`
  margin-top: 16px;
  display: flex;
  gap: 8px;
  align-items: center;
  font-family: "Inter";
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0%;
  color: #62748e;
`;
